import * as Popover$Radix from "@radix-ui/react-popover";
import cx from "clsx";
import CustomButton from "kreate-common/modules/kreate-ui/components/CustomButton";
import React from "react";
import { MdInfoOutline } from "react-icons/md";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  content?: React.ReactNode;
  children?: React.ReactNode;
};

export default function ButtonPopoverInfo({
  className,
  style,
  content,
  children = content,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Popover$Radix.Root>
        <Popover$Radix.Trigger asChild>
          <CustomButton
            className={styles.buttonInfo}
            size="xs-square"
            padding="minimal"
            color="inherit"
            smart={false}
            onClick={(event) => event.stopPropagation()}
          >
            <MdInfoOutline size="24px" />
          </CustomButton>
        </Popover$Radix.Trigger>
        <Popover$Radix.Portal>
          <Popover$Radix.Content className={styles.content} sideOffset={5}>
            {children}
            <Popover$Radix.Arrow fill="black" />
          </Popover$Radix.Content>
        </Popover$Radix.Portal>
      </Popover$Radix.Root>
    </div>
  );
}
